import { render, staticRenderFns } from "./ComponentOnDemand.vue?vue&type=template&id=152b9deb&scoped=true&"
import script from "./ComponentOnDemand.vue?vue&type=script&lang=js&"
export * from "./ComponentOnDemand.vue?vue&type=script&lang=js&"
import style0 from "./ComponentOnDemand.vue?vue&type=style&index=0&id=152b9deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b9deb",
  null
  
)

export default component.exports